module.exports = __webpack_public_path__ + "img/olt_outlawtokenp.28fbd67.png";